const tones = {
  p: 'plain',
  h: 'highlight',
  e: 'error',
}
const classesFor = tone => {
  const spinnerClass = Object.values(tones).includes(tone) ? tone : tones.e
  return `loading-spinner ${spinnerClass}`
}

export const Spinner = ({tone = tones.p}) =>
  <div className={classesFor(tone)} />
